import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './BusinessModelSection.scss';
import _ from 'lodash';
import { getImageUrl } from 'helpers/Utils';
import Heading from '../../common/Heading';
import LazyLoadImg from '../../common/LazyLoadImg';

const BusinessModelSection = ({ column, imageColumn, imageDimensions }) => (
  <div className="businessModelCol">
    {_.get(column, 'row', []).map((item, index) => (
      <Fragment key={item.heading || item.subheading}>
        <Fragment>
          {item && item.heading && imageColumn && (
          <h3 className="heading ourHeading">{item.heading}</h3>
          )}
          {item && item.heading && !imageColumn && (
          <Heading as="h3">{item.heading}</Heading>
          )}
        </Fragment>
        {item && !item.heading && (
          <div className="business-model-section">
            {item.subheading && imageColumn && imageColumn.row[index - 1] && (
            <div className="img-wrapper">
              <LazyLoadImg
                className="image"
                src={getImageUrl(_.get(imageColumn, `row[${index - 1}].image.url`), { width: imageDimensions.businessModelImageWidth })}
                alt={_.get(imageColumn, `row[${index - 1}].image.title`)}
                title={_.get(imageColumn, `row[${index - 1}].image.title`)}
              />
            </div>
            )}
            {item && item.subheading && (
            <div className="txt-wrapper">
              <section>
                <div className="model-inner">{item.subheading}</div>
              </section>
            </div>
            )}
          </div>
        )}
      </Fragment>
    ))}
  </div>
);

BusinessModelSection.propTypes = {
  column: PropTypes.shape({
    row: PropTypes.arrayOf(PropTypes.shape({
      heading: PropTypes.string.isRequired,
      subheading: PropTypes.string,
    })),
  }).isRequired,
  imageDimensions: PropTypes.shape({
    businessModelImageWidth: PropTypes.number,
  }),
  imageColumn: PropTypes.shape({
    row: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    })),
  }),
};

BusinessModelSection.defaultProps = {
  imageColumn: null,
  imageDimensions: {},
};

export default BusinessModelSection;
